<template>
  <v-btn
    v-clipboard:copy="copiable"
    v-clipboard:success="
      (e) => {
        onCopy(e)
        $emit('copySuccess', e)
      }
    "
    v-clipboard:error="onError"
    :class="['mx-auto d-flex my-2', { 'shrink-height': !outlined }]"
    v-bind="{ outlined, color, ...$props, ...$attrs }"
    :title="label"
    :aria-label="label"
    >{{ label
    }}<transition name="fade" mode="out-in"
      ><v-icon
        v-if="copied"
        :right="!!label.length"
        small
        color="green"
        key="copied-check"
        >mdi-check</v-icon
      ><v-icon v-else :right="!!label.length" small key="copy-clippy"
        >mdi-content-copy</v-icon
      ></transition
    ></v-btn
  >
</template>

<script>
export default {
  name: 'BtnCopiable',
  props: {
    label: {
      type: String,
      default: 'Copy',
    },
    copiable: {
      type: [String, Number],
      required: true,
    },
    color: {
      type: String,
      default: 'blue darken-2',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    onCopy() {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 3000)
    },
    onError: function() {
      alert('Failed to copy the text to the clipboard')
    },
  },
}
</script>

<style lang="scss">
.shrink-height {
  height: 35px;
}
</style>
